export enum ObjectType {
  Unknown = "Unknown",
  GraphSkeleton = "GraphSkeleton",
  Generic = "Generic",
  Video = "Video",
  VideoClip = "VideoClip",
  Audio = "Audio",
  AudioClip = "AudioClip",
  Subtitle = "Subtitle",
  Image = "Image",
  ImageSequence = "ImageSequence",
  BundlePackage = "BundlePackage",
  BundleComponent = "BundleComponent",
  TimetoolSequence = "TimetoolSequence",
  DcpPackage = "DcpPackage",
  ImfPackage = "ImfPackage",
  DolbyAtmosPackage = "DolbyAtmosPackage",
  DashPackage = "DashPackage",
  Archive = "Archive",
  Folder = "Folder",
  Document = "Document",
  Font = "Font",
  Metadata = "Metadata",
  MetadataHdr10 = "MetadataHdr10",
  MetadataHdrDolbyVision = "MetadataHdrDolbyVision",
  MetadataDcpAssetMap = "MetadataDcpAssetMap",
  MetadataDcpVolIndex = "MetadataDcpVolIndex",
  MetadataDcpCpl = "MetadataDcpCpl",
  MetadataDcpPkl = "MetadataDcpPkl",
  MetadataImfAssetMap = "MetadataImfAssetMap",
  MetadataImfVolIndex = "MetadataImfVolIndex",
  MetadataImfCpl = "MetadataImfCpl",
  MetadataImfPkl = "MetadataImfPkl",
  MetadataImfOpl = "MetadataImfOpl",
  MetadataProtoolsSession = "MetadataProtoolsSession",
  MetadataDcpKdm = "MetadataDcpKdm",
  MetadataImfKdm = "MetadataImfKdm",
  DolbyAtmosData = "DolbyAtmosData",
  ScribeSubtitleProject = "ScribeSubtitleProject",
  Group = "Group",
  GroupMasterDcp = "GroupMasterDcp",
  GroupMasterImf = "GroupMasterImf",
  Others = "Others",
  KdmContainer = "KdmContainer",
  UploadContainer = "UploadContainer",
  PhysicalBuilding = "PhysicalBuilding",
  PhysicalRoom = "PhysicalRoom",
  PhysicalRack = "PhysicalRack",
  PhysicalPallet = "PhysicalPallet",
  PhysicalBox = "PhysicalBox",
  PhysicalItem = "PhysicalItem",
  VirtualHead = "VirtualHead",
}
